<template>
<div class="chapter">
<div class="inner_page">
<p class="dedic"><a id="page_v"></a><strong><em>Dedication</em></strong></p>
<p class="dedic1"><em>To Skip because I love him,<br/>to Joyce because she’s always in my corner,<br/>and to Toni because she’s my best friend and favorite sister</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedic.vue?84c8535a